<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Movimiento Inventario
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Movimiento Inventario</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formData' (ngSubmit)="buscar(true)">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
        <div></div>
        <button type="button" mdbBtn color="info" (click)="abrirModalAgregarMovimiento()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaInicio"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaFin"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsTipoMovimiento" [multiple]="true" [filterEnabled]="true"
              [highlightFirst]="false" placeholder="Seleccionar Tipo Movimiento" formControlName="tipoMovimiento">
            </mdb-select>
            <label>Tipo Movimiento</label>
          </div>
        </div>
        <!-- <div class="col" style="max-width: 300px;">
                <div class="md-form">
                  <mdb-select
                    [options]="optionsBodega"
                    [multiple]="true"
                    [filterEnabled]="true"
                    [highlightFirst]="false"
                    placeholder="Seleccionar Bodega"
                  ></mdb-select>
                </div>
              </div> -->
        <div class="col" style="max-width: 300px;" *ngIf="showBodegaEntrada">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega Ingreso" formControlName="bodegaIngreso"></mdb-select>
            <label>Bodega Ingreso</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;" *ngIf="showBodegaSalida">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega Salida" formControlName="bodegaSalida"></mdb-select>
            <label>Bodega Salida</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" required
              formControlName="numeroMovimiento" onlyNumbers />
            <label for="rutcliente">Nro. Movimiento</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="info" mdbWavesEffect
            (click)="abrirModalViewMovimiento()">
            <mdb-icon fas icon="eye"></mdb-icon>
          </button>
          <!-- <h6 class="text-info" style="display: contents;">
                          INGRESO 1.000.000
                        </h6> -->
        </div>
        <!-- <div class="col" style="max-width: 300px;">
                <div class="md-form mb-0">
                  <mdb-select
                    [options]="optionsMotivo"
                    [multiple]="true"
                    [filterEnabled]="true"
                    [highlightFirst]="false"
                    placeholder="Seleccionar Motivo"
                  ></mdb-select>
                  <label>Motivo</label>
                </div>
              </div> -->
      </div>


    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>



    <div *ngIf="!loading && listaMovimientos?.length === 0" #alert
      class="alert alert-info alert-dismissible fade show m-0" role="alert">
      <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>No existen registros!</strong> para los filtros seleccionados.
    </div>

    <div class="table-responsive" *ngIf="!loading && listaMovimientos?.length > 0">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Resumen</th>
            <th scope="col">Nro. Mov.</th>
            <th scope="col">Fecha</th>
            <th scope="col">Tipo Mov.</th>
            <th scope="col">Bodega Entrada</th>
            <th scope="col">Bodega Salida</th>
            <th scope="col">Motivo</th>
            <th scope="col" class="text-right">Costo total</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let movimiento of listaMovimientos">
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="loadMovimiento(movimiento)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>{{ movimiento.codigo }}</td>
            <td>{{ movimiento.fecha_movimiento | fecha }}</td>
            <td>{{ movimiento.tipo_movimiento_nombre }}</td>
            <td>{{ movimiento.bodega_nombre_ingreso }}</td>
            <td>{{ movimiento.bodega_nombre_salida }}</td>
            <td>{{ movimiento.referencia }}</td>
            <td class="text-right">{{ movimiento.costo_total | numerico }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar -->
<app-modal-add-movimiento [optionsBodega]="optionsBodega" [optionsTipDocumento]=optionsTipDocumento
  (onSuccess)="onMovimientoInventarioSaved()">
</app-modal-add-movimiento>


<!-- MODAL Consulta movimiento -->
<app-modal-view-movimiento></app-modal-view-movimiento>
